import { TranslationMap } from '@trimble-gcs/i18n-types';

export function scan3dListTranslations() {
  return {
    searchPlaceholder: {
      text: $localize`:@@scan3dList.searchPlaceholder:Find`,
      desc: 'Input placefolder for filtering scan data.',
    },
    filterOptions: {
      allData: {
        text: $localize`:@@scan3dList.filterOptions.allData:All project data`,
        desc: 'The first option in the filter dropdown of the scan 3d list. It shows all project data.',
        limit: 15,
      },
      selectedOnly: {
        text: $localize`:@@scan3dList.filterOptions.selectedOnly:Selected only`,
        desc:
          'The second option in the filter dropdown of the scan 3d list. ' +
          'It shows only data that was previously selected in the project extension ' +
          'to view in the 3d extension.',
        limit: 15,
      },
    },
    station: {
      name: {
        tooltip: {
          text: $localize`:@@scan3dList.station.name.tooltip:Station: {stationName}`,
          desc:
            'Tooltip for the station name displayed above the scan 3d list. ' +
            'This only displays when a station is being viewed in the 3d scene.',
        },
        label: {
          text: $localize`:@@scan3dList.station.name.label:Station: {stationName}`,
          desc: 'Label with the name of the station being displayed in the 3d scene.',
        },
      },
      exit: {
        text: $localize`:@@scan3dList.station.exit:Exit Station`,
        desc: 'Button to exit the station view in 3d scene.',
      },
    },
    scanLoadError: {
      text: $localize`:@@scan3dList.scanLoadError:Error loading data. Please try again later.`,
      desc: 'Error message displayed when scan data fails to load.',
    },
    clipboxBanner: {
      label: {
        text: $localize`:@@scan3dList.clipboxBanner.label:3D clip box active`,
        desc:
          'Label shown in the contextual banner above the scan list whenever a 3D ' +
          'clip box is active in the scene and at least one scan is displayed. The ' +
          'banner offers an action to clip and save the displayed scans inside the ' +
          'clip box to a Trimble Connect folder.',
      },
      action: {
        text: $localize`:@@scan3dList.clipboxBanner.action:Clip and Save`,
        desc:
          'Button in the contextual clip-box banner that opens the Clip and Save ' +
          'panel so the user can pick a destination folder and start the export. ' +
          'Kept short so it fits inside the Connect extension iframe.',
      },
    },
  } satisfies TranslationMap;
}
